import React from "react";
import { message } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { printdocpdf, printdocpdf2up } from "../Services/PrintDocService";

const ExportPdf = ({ numdoc, typeImpression }) => {
  const exportToPDF = () => {
    console.log("Numdoc:", numdoc);
    console.log("Type Impression:", typeImpression);
    const isReduit = typeImpression === "Reduit" || typeImpression === "R";
    if (isReduit) {
      printdocpdf2up(numdoc);
    } else {
      printdocpdf(numdoc);
    }
    message.success("Impression réussie !");
  };

  return (
    <PrinterOutlined
      style={{ cursor: "pointer", color: "#67f02e", marginRight: 8 }}
      onClick={exportToPDF}
    />
  );
};

export default ExportPdf;